import { render, staticRenderFns } from "./frequencyDistrubution.vue?vue&type=template&id=ed82a556&scoped=true&"
import script from "./frequencyDistrubution.vue?vue&type=script&lang=js&"
export * from "./frequencyDistrubution.vue?vue&type=script&lang=js&"
import style0 from "./frequencyDistrubution.vue?vue&type=style&index=0&id=ed82a556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed82a556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCol,VIcon,VProgressCircular,VRow,VTooltip})
